type MessagingContextKeyInput = {
  authUserId?: string | null;
  activeOrganizationId?: string | null;
  activeRoleTemplateCode?: string | null;
  isDelegatedDoctorWorkspace?: boolean;
  doctorControlRequestId?: string | null;
  effectiveDoctorId?: string | null;
};

export const buildMessagingContextKey = ({
  authUserId,
  activeOrganizationId,
  activeRoleTemplateCode,
  isDelegatedDoctorWorkspace = false,
  doctorControlRequestId,
  effectiveDoctorId,
}: MessagingContextKeyInput): string =>
  [
    authUserId ?? "anonymous",
    activeOrganizationId ?? "no-org",
    activeRoleTemplateCode ?? "no-role-template",
    isDelegatedDoctorWorkspace
      ? `delegated:${doctorControlRequestId ?? effectiveDoctorId ?? "unknown-doctor"}`
      : "native",
  ].join(":");
